import { render, staticRenderFns } from "./EntranceGuardSettingPage.vue?vue&type=template&id=b3bc46f2&scoped=true&"
import script from "./EntranceGuardSettingPage.vue?vue&type=script&lang=js&"
export * from "./EntranceGuardSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bc46f2",
  null
  
)

export default component.exports